//    Copyright 2020 Siemens
import {default as SPLM} from "../no/splm.js";
import "../no/Features.js";
import "../Features/Features.FeatureBuilder.js";
import "../GeometricUtilities/GeometricUtilities.BooleanOperation.js";
import "../GeometricUtilities/GeometricUtilities.FeatureOptions.js";
import "../GeometricUtilities/GeometricUtilities.Limits.js";
import "../no/ObjectList.js";
import "../GeometricUtilities/GeometricUtilities.OnPathDimensionBuilder.js";
import "../GeometricUtilities/GeometricUtilities.PlayButtonsBuilder.js";
import "../no/GeometricUtilities.js";
import "../no/ObjectList.js";
let d=[[[0,"AngularTolerance",1,0],[1,"BooleanOperation",0,"GeometricUtilities.BooleanOperation",0],[0,"ConstantFittingSectionCount",1,0],[0,"DistanceTolerance",1,0],[1,"FeatureOptions",0,"GeometricUtilities.FeatureOptions",0],[1,"Limits",0,"GeometricUtilities.Limits",0],[0,"List",1,"ObjectList",0],[0,"MergeFacesOption",1,0],[1,"PathIncrement",0,"GeometricUtilities.OnPathDimensionBuilder",0],[1,"PlayButtons",0,"GeometricUtilities.PlayButtonsBuilder",0],[0,"ReProjectCurvesOption",1,0],[0,"ReviewSection",1,0],[0,"Section",1,"Section",0],[0,"SketchOnPathFeature",0,"Features.Feature",0]],[[[],"NewListItem",{R_:{listitem:"GeometricUtilities.SecondarySectionData"}},0,0]],[]];
SPLM.Features.VarsweepBuilder = class extends SPLM.Features.FeatureBuilder{
    constructor (creator){
        super(creator);
        this._d['Class'] = "SPLM.Features.VarsweepBuilder";
        SPLM.c$d(this.Class,d);d=[];
    }
};

export default SPLM;